// Modernizr
import "./modernizr.js";
// Whirl
import "whirl/dist/whirl.css";
// Font Awesome
import "font-awesome/css/font-awesome.min.css";
// Animate.CSS
import "animate.css/animate.min.css";
// Simple line icons
import "simple-line-icons/css/simple-line-icons.css";



// WEBPACK FOOTER //
// ./src/Vendor.js